import React, { FormEvent, useState } from 'react';
import {
  Container,
  Logo,
  Box,
  Form,
  Input,
  Button,
  ErrorMessage,
} from './LoginStyle';
import { useNavigate } from 'react-router-dom';
import {  Home } from '../../routes/RoutesNames';
import useAuth from '../../hooks/useAuth';
import { Loader } from '../../shared/components/Loader';

const Login = () => {
  const navigate = useNavigate();
  const [login, setLogin] = useState<string>('');
  const [senha, setSenha] = useState<string>(''); //ChangeEvent<HTMLInputElement
  const [liberado, setLiberado] = useState<boolean>();
  const [loading, setLoadging] = useState<boolean>(false);
  const authContext = useAuth()


  const validarLogin = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      setLoadging(true);
      const response = await authContext.signIn(login, senha);

      if (response) {
        navigate(Home);
      } else {
        setLiberado(false);
      }
    } finally {
      setLoadging(false);
    }
  };

  return (
    <React.Fragment>
      <Loader 
        loading={loading}
        >
        <Container>
          <Logo src='/images/promatec.png' alt='Promatec' />
          <Box>
            <Form onSubmit={validarLogin}>
              <Input
                type='text'
                onChange={(text) => {
                  setLogin(text.target.value);
                }}
                placeholder='Login'
              />
              <Input
                type='password'
                onChange={(text) => {
                  setSenha(text.target.value);
                }}
                placeholder='Senha'
              />
              {liberado == false && (
                <ErrorMessage>Login e/ou senha inválidos.</ErrorMessage>
              )}
              <Button type='submit'>Login</Button>
            </Form>
          </Box>
        </Container>
      </Loader>

    </React.Fragment>
  );
};

export default Login;
